import { CONCAT_TEXT_LIMIT, HEADER_TAB_SETUP } from "../../functions/funtion";
import { PT_PROFILE } from "../../routes/stack/paths/pt-profile";
import React from "react";

export default class DAITONN extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      url: "http://daitonn.com/",
    };
  }

  async componentDidMount() {
    await HEADER_TAB_SETUP({
      HeaderTabName: CONCAT_TEXT_LIMIT({
        length: 20,
        string: "DAITONN",
      }),
      FnGoBackScreen: () => {
        this.props.navigate(PT_PROFILE);
      },
      HeaderNavigatorMenuDisplay: false,
      FnHeaderNavigatorMenu: () => {},
    });

  }

  render() {
    return (
      <div style={{ marginTop: 80, width: "90%",  height: 600, marginLeft: "5%" }}>
        <iframe
          title="Daitonn"
          src={this.state.url}
          width={"100%"}
          allowFullScreen
          height={"100%"}
        />
      </div>
    );
  }
}